export default __webpack_public_path__ + "static/media/screen3.da937272.png";